import React, { useEffect, useState } from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/Components/shadcn/input';
import UIStrings from '@/Utils/UIStrings';
import { useClientsOverviewContext } from '../contexts/ClientsOverviewContext';
import useDebounce from '@/Hooks/UseDebounce';

const ClientSearch = () => {
    const { setPagination, setClientFilters } = useClientsOverviewContext();
    const [value, setValue] = useState('');
    const debouncedSearch = useDebounce(value, 300);

    useEffect(() => {
        setPagination((p) => ({ ...p, offset: 0 }));
        setClientFilters((prev) => ({ ...prev, search: debouncedSearch || undefined }));
    }, [debouncedSearch, setPagination, setClientFilters]);

    return (
        <div data-cy="clientSearch" className="relative w-64">
            <Search className="text-muted-foreground absolute top-1/2 left-3.5 size-4 -translate-y-1/2" />
            <Input
                placeholder={UIStrings.SearchCompanies}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                className="bg-background pl-10"
            />
        </div>
    );
};

export default ClientSearch;
